import { nanoid } from 'nanoid';

export function generateGroupId() {
  return nanoid();
}
